import borderRadius from 'polished/lib/shorthands/borderRadius'
import { css } from 'styled-components'
import { theme } from 'utils'

export const inputContainerMargin = css`
  display: flex;
  margin-bottom: ${({ margin }: { margin?: string }) => margin ?? '2rem'};
`

const radius = (side: string) => {
  const size = theme('buttonBorderRadius')
  // @ts-ignore FIXME
  return borderRadius(side, size)
}

const topRadius = radius('top')
const bottomRadius = radius('bottom')

export const inputColumnContainer = css`
  ${inputContainerMargin};
  flex-direction: column;

  div:last-child input,
  div:last-child select {
    position: relative;
    top: -1px;
    ${bottomRadius};
    ${borderRadius('top', 0)};
  }

  div:first-child input,
  div:first-child select {
    ${topRadius};
    ${borderRadius('bottom', 0)};
  }

  div:last-child > label {
    display: none;
  }

  div:not(:first-child):not(:last-child) input,
  div:not(:first-child):not(:last-child) select {
    border-top: none;
    border-bottom: none;
    ${topRadius};
    ${borderRadius('bottom', 0)};
  }

  label + div:last-child:nth-child(2) input,
  label + div:last-child:nth-child(2) select {
    ${topRadius};
    ${bottomRadius};
  }

  div:not(:first-child):not(:last-child) label {
    display: none;
  }
`

export const inputContainerMagicAlign = css`
  ${inputContainerMargin};

  div {
    flex: 1;
    justify-content: flex-end;
  }

  & > div:not(:last-child) {
    margin-right: 1rem;
  }
`

export const inputContainerDescription = css`
  & > div:last-child {
    flex-direction: column;
    align-items: flex-start;
  }
`
